import GetCreditReport from './GetCreditReport'

export default GetCreditReport
